$(document).ready(function(){
  gifScript();
  $('.image-zoom')
      .wrap('<span style="display:inline-block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        url: $(this).find('img').attr('data-zoom')
      });
});


// GIF Script
function gifScript() {
  var vidExist = $('vlink').attr('value');
  var gifExist = $('glink');



var vidExist = $('vlink').attr('value');
var gifExist = $('glink');

if(vidExist !== undefined || vidExist != undefined){
  if(vidExist.match('youtube')){
    $('#product-video').append('<iframe width="100%" height="315" src="'+vidExist+'" frameborder="0" allowfullscreen></iframe>');
  }
  else{
    $('#product-video').append('<h2 class="title text-center">Here is a Quick Video</h2>');
    $('#product-video').append('<video width="100%" height="315" controls><source src="'+vidExist+'" type="video/mp4"></video>');
  }
}


if(gifExist !== undefined || gifExist != undefined){
  $('glink').each(function(){
    var glink_src = $(this).attr('value');
    var glink_behavior = $(this).attr('behavior');
    if( glink_behavior == "video" ){
      $('#product-video').append('<img src='+glink_src+' style="width:100%;">');
    }
    else if( glink_behavior == "thumbnail" ){      
      // var dyna_image = "<div class='product-single__photo-wrapper gif_link' id='thumbnails'><a href="+glink_src+"><img class='product-single__photo' src="+glink_src+" {% if settings.product_zoom_enable %}data-mfp-src="+glink_src+"{% endif %}></a></div>";
      // $('.gif_link a').attr('href',glink_src);
      // $('.gif_link img').attr('src',glink_src);
      // $('.product-single__photos').append(dyna_image);
      $('<center id="sticky-gif" ><img class="custom-gif" src='+glink_src+' style="width:90%;margin: 20px 5% 0 5%;"></center>').insertAfter($('.product_slider'));
    }
    else if( glink_behavior == "desc" ){
      var glink_class = $(this).attr('class-name');
      var glink_order = $(this).attr('order');
      var glink_adjacent = $(this).attr('adjacent');
      var glink_width = $(this).attr('scale-x');
      var glink_height = $(this).attr('scale-y');
      if(glink_adjacent != undefined || glink_adjacent == "true"){
        $('<center><img class='+ glink_class +' src='+glink_src+' style="width:'+glink_width+';height:'+glink_height+';margin-bottom: 15px;float:left;"></center>').insertAfter('.order_'+glink_order); 
      } else {
        // $('<center><img class='+ glink_class +' src='+glink_src+' style="width:'+glink_width+';height:'+glink_height+';margin-bottom: 15px;"></center>').insertAfter('.product_gallery');

        $('.tab-item#tab-1').append($('<center><img class='+ glink_class +' src='+glink_src+' style="width:'+glink_width+';height:'+glink_height+';margin-bottom: 15px;"></center>'));
      }
    }
  })
}
////////////////////////////////
var getDescriptionHeight = $('.product_section').height();
console.log(getDescriptionHeight);
$('.sticky-gif').css('height', getDescriptionHeight + 200 + 'px');
$("#sticky-gif").stick_in_parent({offset_top: 100}); 
}